<template>
  <div class="echartsfather">
    <div id="bcharts" :style="bchartsStyle"></div>
    <div class="tab-switch">
      <span
        v-for="item in tabData"
        :class="[{'current': tabKey==item}]"
        v-text="item"
        :key="item"
        @click="tabSwitch(item);dataChang(item)"
      ></span>
    </div>
  </div>
</template>
<script>
export default {
  name: "echarts05",
  props: {
    bchartsStyle: {
      type: Object,
      default: () => {
        return { width: "422px", height: "211px" };
      }
    },
    echarts06Data: {
      type: Array,
      default: () => {
        return [
          { value: 10, name: "提升机" },
          { value: 5, name: "拆垛机" },
          { value: 15, name: "输送机" },
          { value: 25, name: "顶升移栽" },
          { value: 20, name: "堆垛机" },
          { value: 35, name: "拆码盘机" },
          { value: 30, name: "夹抱机" }
        ];
      }
    }
  },
  data() {
    let tabData = ["日", "周", "月"];
    //获取今日12点前时间
    let endTime = new Date(
      new Date(new Date().toLocaleDateString()).getTime() +
        24 * 60 * 60 * 1000 -
        1
    );
    return {
      tabData: tabData,
      tabKey: tabData[0],
      settime: endTime
    };
  },
  mounted() {
    this.pies();
  },
  methods: {
    tabSwitch(item) {
      // console.log(item);
      this.tabKey = item;
      //   this.getGzsjhzList();
    },
    dataChang(val) {
      this.$emit("receiveData", val);
    },
    pies() {
      var _this = this;
      var behaviorpie = this.$echarts.init(document.getElementById("bcharts"));
      var option = {
        color: [
          "#00CAF2",
          "#F0F401",
          "#8B79FF",
          "#43F45C",
          "#EF5F47",
          "#5A48FF",
          "#43FFB2"
        ],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b} : {c} ({d}%)"
        },
        legend: {
          // type: "scroll",
          orient: "vertical",
          show: true,
          left: 10,
          bottom: 28,
          icon: "circle",
          itemWidth: 10, // 图例图形宽度
          itemHeight: 10, // 图例图形高度
          textStyle: {
            fontSize: 12,
            color: "#000"
          },
          data: _this.echarts06Data
        },
        calculable: true,
        series: [
          {
            name: "故障汇总",
            type: "pie",
            radius: [20, 60],
            center: ["55%", "50%"],
            roseType: "area",
            data: _this.echarts06Data,
            label: {
              normal: {
                formatter: "{d}%",
                show: true,
                position: "end", //文字显示位置
                textStyle: {
                  fontSize: "14",
                  fontWeight: "normal"
                }
              }
            },
            lableLine: {
              normal: {
                show: true,
                length: "1"
                // avoidLabelOverlap: false
              }
            }
          }
        ]
      };

      behaviorpie.setOption(option);
    }
  }
};
</script>
<style scoped>
.echartsfather {
  width: 422px;
  height: 211px;
  position: relative;
  margin-top: 125px;
  margin-left: 15px;
}
.tab-switch {
  width: 40px;
  height: 100%;
  position: absolute;
  right: 0px;
  top: 30px;
}
.tab-switch span {
  color: #fff;
  font-size: 12px;
  text-align: center;
  width: 30px;
  padding: 3px;
  margin: 10px 2px;
  line-height: 20px;
  height: 20px;
  display: inline-block;
  background-color: #1b406d;
  border-radius: 5px;
  font-weight: 600;
}
.current {
  background: #07afa1 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/xiayan/home/home/echarts5.vue